import React from 'react';
import ReactDOM from 'react-dom';
import { Form as AntForm, Input, Select, Button, Modal, Spin } from 'antd';
import { Form, Scenario } from 'rx-model';
import {
  PresenceValidator, EmailValidator, StringValidator,
  CompareValidator, CustomValidator
} from 'rx-model/validators';
import { FormConnect } from 'react-rx-form';

class UserForm extends Form {
  // правила валидации
  rules() {
    return {
      name: new PresenceValidator(),
      email: [
        new PresenceValidator(),
        new EmailValidator(),
        // кастомный асинхронный валидатор
        new CustomValidator({
          func: (value, attribute, model) => {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                if (value === 'foo@mail.com' || value === 'bar@mail.com') {
                  reject(`Email ${value} уже зарегестрирован в системе.`);
                } else {
                  resolve();
                }
              }, 1000);
            })
          }
        })
      ],
      password: [
        new PresenceValidator(),
        new StringValidator({
          minLength: 6
        }),
        // данное правило будет применено только при авторизации
        Scenario.in([UserForm.SCENARIO_AUTHORIZE], new CustomValidator({
          func: (value, attribute) => {
            return value === 'swordfish'
              ? Promise.resolve()
              : Promise.reject('Unknown password!');
          }
        }))
      ],
      confirmPassword: [
        new PresenceValidator(),
        new CompareValidator({
          compareAttribute: 'password',
          message: 'Подтвердите пароль'
        })
      ]
    }
  }

  // сценарии работы с моделью
  static SCENARIO_AUTHORIZE = 'authorize';
  static SCENARIO_REGISTER = 'register';
  static SCENARIO_EDIT = 'edit';
  static SCENARIO_CHANGE_PASSWORD = 'changePassword';

  // определим правила применимые для каждого сценария
  scenarios() {
    return {
      [UserForm.SCENARIO_DEFAULT]: [],
      [UserForm.SCENARIO_AUTHORIZE]: ['email', 'password'],
      [UserForm.SCENARIO_EDIT]: ['name'],
      [UserForm.SCENARIO_REGISTER]: ['name', 'email', 'password'],
      [UserForm.SCENARIO_CHANGE_PASSWORD]: ['password', 'confirmPassword'],
    }
  }
}

const FormItem = AntForm.Item;
const Option = Select.Option;

export default class UserFormComponent extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form: new UserForm()
    };

    // this.state.form.getValidationObservable().subscribe(state => console.log(state));

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeScenario = this.handleChangeScenario.bind(this);
  }

  setAttributeRef(attr, el) {
    this[`attr_${attr}`] = el;
  }

  getAttributeRef(attr) {
    return this[`attr_${attr}`];
  }

  // фокус компонента не прошедшего валидацию
  focus(component) {
    if (component.focus) {
      component.focus();
    } else if (component.getWrappedInstance) {
      component = component.getWrappedInstance();
      this.focus(component);
    } else {
      component = ReactDOM.findDOMNode(component);
      component && component.focus();
    }
  }

  handleSubmit() {
    const { form } = this.state;

    form.validate().then(isValid => {
      if (isValid) {
        const attributes = form.getAttributes();

        Modal.success({
          title: 'Attributes',
          content: <pre>{JSON.stringify(attributes, null, "  ")}</pre>,
        })
      } else {
        const error = form.getFirstError();
        const component = this.getAttributeRef(error.attribute);

        component && this.focus(component);
      }
    })
  }

  handleChangeScenario(scenario) {
    this.state.form.setScenario(scenario);

    this.forceUpdate();
  }

  render() {
    const { form } = this.state;

    return (
      <AntForm>
        <FormItem label={<span>Сценарий формы</span>}>
          <Select
            onChange={this.handleChangeScenario}
            value={form.getScenario()}
          >
            <Option value={UserForm.SCENARIO_DEFAULT}>По умолчанию</Option>
            <Option value={UserForm.SCENARIO_REGISTER}>Регистрация</Option>
            <Option value={UserForm.SCENARIO_AUTHORIZE}>Авторизация</Option>
            <Option value={UserForm.SCENARIO_EDIT}>Редактирование</Option>
            <Option value={UserForm.SCENARIO_CHANGE_PASSWORD}>Смена пароля</Option>
          </Select>
        </FormItem>

        <FormConnect
          form={form}
          whenModel={['name']}
        >{() => {
          return <FormItem
            label={<span><b>name</b></span>}
            validateStatus={form.getValidationStatus('name')}
            help={form.getValidationError('name')}
            required={form.isAttributeRequired('name')}
          >
            <Input
              ref={el => this.setAttributeRef('name', el)}
              value={form.getAttribute('name')}
              onChange={(e) => form.setAttribute('name', e.target.value)}
              onBlur={() => form.validateAttributes(['name'])}
              disabled={!form.isAttributeSafe('name')}
            />
          </FormItem>
        }}</FormConnect>

        <FormConnect
          form={form}
          whenModel={['email']}
        >{() => {
          return <FormItem
            label={<span><b>email</b> (кроме <i>foo@mail.com</i> и <i>bar@mail.com</i>, асинхронная валидация)</span>}
            validateStatus={form.getValidationStatus('email')}
            help={form.getValidationError('email')}
            required={form.isAttributeRequired('email')}
          >
            <Input
              ref={el => this.setAttributeRef('email', el)}
              value={form.getAttribute('email')}
              onChange={(e) => form.setAttribute('email', e.target.value)}
              onBlur={() => form.validateAttributes(['email'])}
              suffix={form.isAttributePending('email') && <Spin />}
              disabled={!form.isAttributeSafe('email')}
            />
          </FormItem>
        }}</FormConnect>

        <FormConnect
          form={form}
          whenModel={['password']}
        >{() => {
          return <FormItem
            label={<span><b>password</b> (минимум 6 символов)</span>}
            validateStatus={form.getValidationStatus('password')}
            help={form.getValidationError('password')}
            required={form.isAttributeRequired('password')}
          >
            <Input
              ref={el => this.setAttributeRef('password', el)}
              type="password"
              value={form.getAttribute('password')}
              onChange={(e) => form.setAttribute('password', e.target.value)}
              onBlur={() => form.validateAttributes(['password'])}
              disabled={!form.isAttributeSafe('password')}
            />
          </FormItem>
        }}</FormConnect>

        <FormConnect
          form={form}
          whenModel={['confirmPassword']}
        >{() => {
          return <FormItem
            label={<span><b>confirmPassword</b> (подтвердить пароль)</span>}
            validateStatus={form.getValidationStatus('confirmPassword')}
            help={form.getValidationError('confirmPassword')}
            required={form.isAttributeRequired('confirmPassword')}
          >
            <Input
              ref={el => this.setAttributeRef('confirmPassword', el)}
              type="password"
              value={form.getAttribute('confirmPassword')}
              onChange={(e) => form.setAttribute('confirmPassword', e.target.value)}
              onBlur={() => form.validateAttributes(['confirmPassword'])}
              disabled={!form.isAttributeSafe('confirmPassword')}
            />
          </FormItem>
        }}</FormConnect>

        <FormItem>
          <Button onClick={this.handleSubmit}>Submit</Button>
        </FormItem>
      </AntForm>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/forms/UserForm.js